<script setup>
import AppLayout from '~/components/layout/AppLayout.vue';
</script>
<template>
  <app-layout>
    <nuxt-page />
  </app-layout>
</template>
